import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function BitBucketIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M1.03125 1.5L22.9219 1.54688C22.9219 1.54688 22.9688 1.54688 23.0156 1.54688C23.3906 1.59375 23.6719 1.92188 23.6719 2.29688C23.6719 2.34375 23.6719 2.34375 23.6719 2.39062L20.4844 21.9375C20.3906 22.3125 20.1094 22.5469 19.7344 22.5469H4.45312C3.9375 22.5469 3.51562 22.1719 3.46875 21.7031L0.28125 2.39062C0.28125 2.34375 0.28125 2.29688 0.28125 2.25C0.28125 1.875 0.609375 1.5 0.984375 1.5C1.03125 1.5 1.03125 1.5 1.03125 1.5ZM14.4375 15.4688L15.6094 8.57812H8.25L9.5625 15.4688H14.4375Z"
        fill="currentColor"
      />
    </svg>
  );
};
